export default __webpack_public_path__ + "static/symmetrical-ed07b1c084dcadde042cc5e93dccbb97.png";